import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Nosotros1 from "../components/Nosotros/Nosotros";
import Nosotros2 from "../components/Nosotros/Nosotros2";
import Nosotros3 from "../components/Nosotros/Nosotros3";
import Nosotros4 from "../components/Nosotros/Nosotros4";
import Nosotros5 from "../components/Nosotros/Nosotros5";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Faq from "../components/Nosotros/Faq";

export function Nosotros() {
  const { t } = useTranslation();
  const pathByLang = t("seo.about.pathByLang", { returnObjects: true });

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
  }, []);

  return (
    <div className="bg-color-white-gradient">
      <Seo pageKey="about" pathByLang={pathByLang} />
      <Navbar />
      <Nosotros1 />
      <Nosotros2 />
      <Nosotros3 />
      <Nosotros4 />
      <Faq />
      <Nosotros5 />
    </div>
  );
}
